<template>
	<div
		class="row h-100"
	>
		<div
			class="col-12"
			:class="{'align-self-center': lazyStep === 1}"
		>
			<transition
				:name="step > 0 ? 'slide-fadein-left' : 'slide-fadein-right'"
				mode="out-in"
			>
				<div
					v-if="step===0"
					key="0"
					class="steps-content"
				>
					<g-table-sync
						:app="app"
						:view="view"
						pagination="loadmore"
						:default-limit="12"
						:columns="columns"
						@edit="edit"
					>
						<template
							slot="imagen"
							slot-scope="item"
						>
							IMAGEN {{ item._EntityId }}
						</template>

						<template
							slot="precio"
							slot-scope="item"
						>
							{{ item.ProductoPrecio }}€
						</template>

						<!-- <template
							slot="tipo"
							slot-scope="item"
						>
							{{ item.ProductoTipo === 1 ? 'Producto' : '' }}%
						</template> -->

						<template
							slot="pago"
							slot-scope="item"
						>
							{{ paymentType(item.ProductoRecurrencia) }}
						</template>
					</g-table-sync>
				</div>

				<div
					v-if="step===1"
					key="1"
				>
					<div class="row align-items-center ">
						<div class="col-12 col-md-6 px-5">
							<img
								src="@/application/assets/images/add_product.webp"
								class="img-fluid mx-auto"
							>
						</div>
						<div class="col-12 col-md-6">
							<validation-observer v-slot="{ passes, invalid }">
								<form @submit.prevent="passes(save)">
									<div class="d-flex align-items-center">
										<div>
											<h2
												v-if="id === 0"
												class="mb-0 font-weight-bold text-uppercase"
											>
												Nuevo producto
											</h2>

											<h2
												v-else
												class="mb-0 font-weight-bold text-uppercase"
											>
												Editar producto
											</h2>

											<h4 class="text-muted mb-3">
												Controla tu stock y estadísticas de ventas
											</h4>
										</div>
									</div>

									<p class="text-justify">
										Categoriza tus tipos de facturas en numeros de serie distintos. Puedes
										crear los numeros de serie que necesites y luego escoger el que necesites a
										la hora de realizar una nueva factura. Cada numero de serie lleva una
										numeración distinta y puede ser personalizada tal como necesites.
									</p>

									<a-divider dashed>
										<fa-icon
											icon="info"
											class="mr-2"
										/> General
									</a-divider>

									<div class="row">
										<div class="col-6">
											<g-field
												v-model="fields.ProductoNombre"
												:disabled="loading"
												:app="app"
												:item="id"
												name="ProductoNombre"
												placeholder=""
												title="Nombre"
											/>
										</div>

										<div class="col-6">
											<g-field
												v-model="fields.ProductoTipo"
												:disabled="loading"
												:app="app"
												:item="id"
												name="ProductoTipo"
												placeholder="Valor"
												title="Tipo"
											/>
										</div>
									</div>

									<div class="row">
										<div class="col-12">
											<g-field
												v-model="fields.ProductoDescripcion"
												:disabled="loading"
												:app="app"
												:item="id"
												name="ProductoDescripcion"
												placeholder=""
												title="Descripción"
												type="textarea"
											/>
										</div>
									</div>

									<a-divider dashed>
										<fa-icon
											icon="coins"
											class="mr-2"
										/> Costes
									</a-divider>

									<div class="row">
										<div class="col-6">
											<g-field
												v-model="fields.ProductoPrecio"
												:disabled="loading"
												:app="app"
												:item="id"
												name="ProductoPrecio"
												title="Precio (€)"
											/>
										</div>

										<div class="col-6">
											<g-field
												v-model="fields.ProductoRecurrencia"
												:disabled="loading"
												:app="app"
												:item="id"
												name="ProductoRecurrencia"
												title="Recurrencia (meses)"
											/>
										</div>
									</div>

									<div class="text-muted py-3 d-flex align-items-center">
										<a-button
											type="link"
											@click="step = 0; reset();"
										>
											<fa-icon
												:icon="['fas','chevron-left']"
												class="mr-2"
											/> Cancelar
										</a-button>
										<div class="ml-auto" />
										<a-popconfirm
											title="¿Estas seguro que deseas limpiar todo el formulario?"
											@confirm="() => reset()"
										>
											<a-button
												type="danger"
												class="mr-2"
												:disabled="loading"
											>
												<fa-icon
													:icon="['fas','brush']"
													class="mr-2"
												/> Limpiar
											</a-button>
										</a-popconfirm>

										<a-button
											v-if="id === 0"
											type="primary"
											html-type="submit"
											:disabled="invalid"
											:loading="loading"
										>
											<fa-icon
												:icon="['fas','plus-square']"
												class="mr-2"
											/> Añadir
										</a-button>

										<a-button
											v-else
											type="primary"
											html-type="submit"
											:disabled="invalid"
											:loading="loading"
										>
											<fa-icon
												:icon="['fas','edit']"
												class="mr-2"
											/> Modificar
										</a-button>
									</div>
								</form>
							</validation-observer>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProductosList',
	data() {
		return {
			app: 'productos',
			view: 'productos_list',
			id: 0,
			step: 0,
			lazyStep: 0,
			loading: false,
			fields: {
				ProductoNombre: '',
				ProductoDescripcion: '',
				ProductoPrecio: 0,
				ProductoRecurrencia: 0,
				ProductoTipo: 1
				// ProductoCaducidad: null,
				// ProductoImagen: null,
				// Productos: []
			},
			columns: [
				{
					title: 'Imagen',
					index: 'ProductoImagen',
					slot: 'imagen'
				},
				{
					title: 'Nombre',
					index: 'ProductoNombre',
					order: true,
					search: true
				},
				{
					title: 'Precio',
					index: 'ProductoPrecio',
					slot: 'precio',
					order: true
				},
				{
					title: 'Tipo',
					index: 'ProductoTipo',
					slot: '_select',
					order: true,
					filters: [
						{
							text: 'Producto simple',
							value: '1'
						},
						{
							text: 'Pack',
							value: '2'
						}
					]
				},
				{
					title: 'Pago',
					index: 'ProductoRecurrencia',
					slot: 'pago',
					order: true
				},
				{
					title: 'Acciones',
					slot: '_actions'
				}
			]
		};
	},

	watch: {
		step(val) {
			setTimeout(() => {
				this.lazyStep = val;
			}, 400);
		}
	},
	created() {
		this.$hub.$on('newProducto', () => {
			this.reset();
			this.id = 0;
			this.step = 1;
		});
	},
	methods: {
		edit(item) {
			this.step = 1;
			this.id = item._EntityId;
		},
		reset() {
			this.fields = {
				ProductoNombre: '',
				ProductoDescripcion: '',
				ProductoPrecio: 0,
				ProductoRecurrencia: 0,
				ProductoTipo: 1
				// ProductoCaducidad: null,
				// ProductoImagen: null,
				// Productos: []
			};
		},
		paymentType(type) {
			if (type === 0) {
				return 'Único';
			} if (type === 1) {
				return 'Único';
			} if (type === 2) {
				return 'Bimensual';
			} if (type === 3) {
				return 'Trimestral';
			} if (type === 4) {
				return 'Cuatrimestral';
			} if (type === 6) {
				return 'Semestral';
			} if (type === 12) {
				return 'Anual';
			}
			return `Cada ${type} meses`;
		},
		async save() {
			this.loading = true;

			let result;
			if (this.id > 0) {
				result = await this.$gestios.items(this.app).edit({
					params: this.fields,
					id: this.id
				});

				if (result.ok) {
					this.$toast.success('Producto modificado correctamente');
					this.reset();
					this.step = 0;
				}
			} else {
				result = await this.$gestios.items(this.app).add({
					params: this.fields,
					view: this.view
				});

				if (result.ok) {
					this.$toast.success('Producto dado de alta correctamente');
					this.reset();
					this.step = 0;
				}
			}

			this.loading = false;
		}
	}
};
</script>

<style lang="scss">

</style>
